<template>
  <div>
    <v-row align="center" style="margin: 20px">
      <v-col class="d-flex" cols="12" sm="6" lg="4">
        <v-select
          :items="items"
          item-text="text"
          item-value="value"
          v-model="type"
          @change="getAllMessages()"
        ></v-select>
      </v-col>
    </v-row>
    <div v-if="messages.length > 0">
      <app-summary
        v-for="index in messages.length"
        :key="index - 1"
        :message="messages[index - 1]"
        :index="index - 1"
        @selected="readMessage(index - 1)"
      >
      </app-summary>
    </div>
    <app-detail
      v-if="showModal"
      @close="showModal = false"
      :title="messages[selectedIndex].Title"
      :body="messages[selectedIndex].Body"
      :imageUrl="messages[selectedIndex].ImageUrl"
      :sendDate="sendDate"
      :link="messages[selectedIndex].Link"
      :showRight="selectedIndex < messages.length - 1"
      :showLeft="selectedIndex > 0"
      @showNext="readMessage(selectedIndex + 1)"
      @showPrevious="readMessage(selectedIndex - 1)"
    >
    </app-detail>
    <div v-else style="margin: 20px 50px">
      {{ apiRunning ? "" : "شما هیچ پیامی ندارید" }}
    </div>
  </div>
</template>

<script>
import Summary from "./Summary";
import Detail from "./Detail";
export default {
  components: {
    appSummary: Summary,
    appDetail: Detail,
  },
  data() {
    return {
      items: [
        { value: "3", text: "پیام های خوانده نشده" },
        { value: "2", text: "پیام های خوانده شده" },
        { value: "1", text: "پیام های فعال" },
        { value: "0", text: "همه پیام ها" },
      ],
      type: "3",
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
    };
  },
  created() {
    this.getAllMessages();
  },
  computed: {
    messages() {
      return this.$store.getters.messages;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    sendDate() {
      return this.toJalaliDateTime(this.messages[this.selectedIndex].SentDate);
    },
  },
  watch: {
    showModal(value) {
      if (value) {
        this.scrollY = window.scrollY;
      }

      document.querySelector("body").style.overflow = value
        ? "hidden"
        : "unset";
      document.querySelector("body").style.height = value ? "100%" : "unset";
      if (!value) {
        window.scrollTo(0, this.scrollY);
      }
    },
  },
  methods: {
    hideModal() {
      this.showModal = false;
    },
    getAllMessages() {
      this.$store.dispatch("getAllMessagesV2", this.type);
    },
    /**
     * open modal selectedIndex
     */
    readMessage(index) {
      this.selectedIndex = index;
      this.showModal = true;
      if (this.messages[this.selectedIndex].readDate == "") {
        this.$store
          .dispatch("setMessageAsRead", {
            id: this.messages[index].Id,
            index: index,
          })
          .then(() => {
            this.$store.commit(
              "SET_UNREAD_MESSAGE_COUNT",
              this.$store.getters.UnreadMessagesCount - 1
            );
          });
      }
    },
  },
};
</script>
<style>
</style>
